














































































import OrgSiteManagementSelectSite from '@/components/org-site-management/OrgSiteManagementSelectSite.vue'
import OrgSiteManagementSelectUnit from '@/components/org-site-management/OrgSiteManagementSelectUnit.vue'
import OrgSiteManagementManageUnit from '@/components/org-site-management/OrgSiteManagementManageUnit.vue'

// import OrgSiteManagementAddDevices from '@/components/org-site-management/OrgSiteManagementAddDevices.vue'
// import OrgSiteManagementAddDeviceSerialNumbers from '@/components/org-site-management/OrgSiteManagementAddDeviceSerialNumbers.vue'
// import OrgSiteManagementReview from '@/components/org-site-management/OrgSiteManagementReview.vue'
// import OrgSiteManagementDone from '@/components/org-site-management/OrgSiteManagementDone.vue'

import {
  OrgSiteManagementDefaultDevice,
  OrgSiteManagementDeviceTypeUploadKeys,
  OrgSiteManagementWizardBackButtonActionNames,
  OrgSiteManagementWizardNextButtonActionNames,
  OrgSiteManagementWizardStages,
  needsSerialNumber,
} from '@/constants/org-site-management'
import { ActionNames as SiteActionNames } from '@/store/modules/site/keys'
import { mapActions } from 'vuex'
import { ModuleNames } from '@/store/module-names'

export default {
  components: {
    OrgSiteManagementSelectSite,
    OrgSiteManagementSelectUnit,
    OrgSiteManagementManageUnit,

    // OrgSiteManagementAddDevices,
    // OrgSiteManagementAddDeviceSerialNumbers,
    // OrgSiteManagementReview,
    // OrgSiteManagementDone,
  },

  data() {
    return {
      orgSiteManagementWizardStages: null,
      orgSiteManagementWizardCurrentStageIndex: 0,
      orgSiteManagementWizardCurrentSelectedDeviceIndex: 0,
      wizardIsInProgress: false,
      site: null,
      unit: null,
      devices: [],
      submittedDevices: false,
      isSavingData: false,
      errorMessage: null,
    }
  },

  computed: {
    orgSiteManagementWizardCurrentStage() {
      return this.orgSiteManagementWizardStages[this.orgSiteManagementWizardCurrentStageIndex]
    },
    orgSiteManagementWizardProgressIndicator() {
      return this.orgSiteManagementWizardStages.map((stage, index) => ({
        ...stage,
        hasLink: index < this.orgSiteManagementWizardStages.length - 1,
        isCurrent: index === this.orgSiteManagementWizardCurrentStageIndex,
        isComplete: index < this.orgSiteManagementWizardCurrentStageIndex,
      }))
    },
    siteManagementWizardActionButtons() {
      return [
        {
          text: this.isFirstWizardStage ? 'Start Again' : 'Go Back',
          isNeutral: true,
          isOutlined: this.isFirstWizardStage,
          color: this.isFirstWizardStage ? 'red' : 'light-grey',
          action: this.isFirstWizardStage
            ? () => this.initOrgSiteManagementWizard()
            : this.orgSiteManagementWizardBackButtonAction,
          isDisabled: !this.canGoToPreviousWizardStage,
          isShown: this.showPreviousWizardStageButton,
        },
        {
          text: this.isLastWizardStage ? 'Done' : this.orgSiteManagementWizardCurrentStage.nextButtonText,
          color: 'primary',
          action: this.orgSiteManagementWizardNextButtonAction,
          isDisabled: !this.canProgressToNextWizardStage,
          isShown: true,
        },
      ].filter(b => b)
    },
    canProgressToNextWizardStage() {
      return this.orgSiteManagementWizardCurrentStage.canProgress
    },
    canGoToPreviousWizardStage() {
      return this.wizardIsInProgress
    },
    showPreviousWizardStageButton() {
      return true
    },
    numberOfOrgSiteManagementWizardStages() {
      return this.orgSiteManagementWizardStages.length
    },
    isFirstWizardStage() {
      return this.orgSiteManagementWizardCurrentStageIndex === 0
    },
    isLastWizardStage() {
      return this.orgSiteManagementWizardCurrentStageIndex === this.numberOfOrgSiteManagementWizardStages - 1
    },
    shouldUploadDevices() {
      return this.orgSiteManagementWizardCurrentStage.uploadDevicesOnNextClick!! && !this.submittedDevices
    },
  },

  created() {
    this.initOrgSiteManagementWizard()
  },

  mounted() {},

  beforeDestroy() {
    clearInterval(this.currentGatewayPollInterval)
  },

  beforeRouteLeave(to, from, next) {
    if (this.wizardIsInProgress) {
      return next(this.confirmAbandonProgress())
    }
    next()
  },

  methods: {
    ...mapActions(ModuleNames.site, [SiteActionNames.patchSite]),
    initOrgSiteManagementWizard(requireConfirmation = true) {
      if (this.wizardIsInProgress && requireConfirmation) {
        const confirmation = this.confirmAbandonProgress()
        if (!confirmation) {
          return
        }
      }
      this.buildWizardStages()
      this.resetWizardData()
    },
    orgSiteManagementWizardNextButtonAction() {
      this[this.orgSiteManagementWizardCurrentStage.nextButtonAction]()
    },
    orgSiteManagementWizardBackButtonAction() {
      this[this.orgSiteManagementWizardCurrentStage.backButtonAction]()
    },
    [OrgSiteManagementWizardNextButtonActionNames.NextWizardStage](): void {
      if (this.isLastWizardStage) {
        return this.initOrgSiteManagementWizard(false)
      }

      if (this.shouldUploadDevices) {
        this.uploadDevicesAsync()
      }

      this.orgSiteManagementWizardCurrentStageIndex += 1
    },
    [OrgSiteManagementWizardBackButtonActionNames.PreviousWizardStage](): void {
      this.submittedDevices = false
      this.orgSiteManagementWizardCurrentStageIndex -= 1
    },
    [OrgSiteManagementWizardBackButtonActionNames.PreviousSelectedDevice]() {
      if (this.orgiteManagementWizardCurrentSelectedDeviceIndex >= 1) {
        return (this.orgSiteManagementWizardCurrentSelectedDeviceIndex -= 1)
      }
      this[OrgSiteManagementWizardBackButtonActionNames.PreviousWizardStage]()
    },
    selectSite(site): void {
      this.site = site
    },
    selectUnit(unit): void {
      this.unit = unit
    },
    updateDevicesToAdd(payload): void {
      // do some combining in case people add the same device type twice...
      let payloadOut = []
      payload.forEach(d => {
        let matching = payloadOut.filter(p => p.type === d.type)
        if (matching && matching.length && matching[0]) matching[0].quantity += d.quantity
        else payloadOut.push(d)
      })
      // then add a unit for the qty of devices that need a serial number
      payloadOut.forEach(d => {
        if (needsSerialNumber(d.type)) {
          d.units = []
          for (let i = 0; i < d.quantity; i++) {
            d.units.push({ serialNumber: null })
          }
        } else {
          d.units = null
        }
      })
      this.devices = payloadOut
    },
    updateStageValidity(payload: { stageIndex: number; isValid: boolean }): void {
      this.wizardIsInProgress = true
      this.orgSiteManagementWizardStages[payload.stageIndex].canProgress = payload.isValid
    },
    confirmAbandonProgress(): boolean {
      return confirm(
        `Progress may be lost if you leave the ${this.chosenOrgSiteManagementAction} workflow at this stage. Are you sure you wish to leave?`
      )
    },
    resetWizardData() {
      this.wizardIsInProgress = false
      this.site = null
      this.unit = null
      this.devices = [
        {
          ...OrgSiteManagementDefaultDevice,
          deviceIndex: 0,
        },
      ]
      this.submittedDevices = false
      this.orgSiteManagementWizardCurrentStageIndex = 0
      this.orgSiteManagementWizardCurrentSelectedDeviceIndex = 0
    },
    buildWizardStages() {
      //NEEDS TYPING
      this.orgSiteManagementWizardStages = OrgSiteManagementWizardStages.map((stage, index) => ({
        ...stage,
        stageNumber: index + 1,
        canProgress: false,
      }))
    },

    async uploadSiteDetails(payload) {
      this.site = payload
      console.log('saving site details')
      this.isSavingData = true
      this.errorMessage = null
      try {
        await this.patchSiteDetails(payload)
        this.errorMessage = null
      } catch (e) {
        this.errorMessage = 'Failed to save site details'
        console.error(e)
      }
      this.isSavingData = false
      // this.emitSite()
    },

    async patchSiteDetails(site) {
      await this[SiteActionNames.patchSite]({
        id: site.id,
        attributes: site,
      })
    },

    async uploadDevicesAsync() {
      this.isSavingData = true
      this.submittedDevices = true
      this.errorMessage = null
      let siteWithDevices = {
        ...this.site,
        devicesToAssign: this.devices.map(function(d) {
          let d2 = { ...d }
          d2.type = OrgSiteManagementDeviceTypeUploadKeys[d2.type]
          return d2
        }),
      }

      try {
        await this.patchSiteDetails(siteWithDevices)
        this.errorMessage = null
      } catch (e) {
        this.errorMessage = "Failed to save site's devices"
        console.error(e)
      }
      this.isSavingData = false
    },
  },
}
